'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _edit = require('./edit');

var _edit2 = _interopRequireDefault(_edit);

var _parse2 = require('./parse');

var _parse3 = _interopRequireDefault(_parse2);

var _format = require('./format');

var _format2 = _interopRequireDefault(_format);

var _dom = require('./dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input_controller = function () {
	function Input_controller(get_input_element, parse, format, on_change) {
		(0, _classCallCheck3.default)(this, Input_controller);

		_initialiseProps.call(this);

		if (typeof get_input_element !== 'function') {
			(function () {
				var element = get_input_element;
				get_input_element = function get_input_element() {
					return element;
				};
			})();
		}

		this.get_input_element = get_input_element;
		this.parse = parse;
		this.format = format;
		this.on_change = on_change;
	}

	// Special handling for "Cut" event because
	// it wouldn't copy to clipboard otherwise.


	// Intercepts "Delete" and "Backspace" keys
	// (hitting "Delete" or "Backspace"
	//  at any caret position should always result in
	//  erasing a digit)


	(0, _createClass3.default)(Input_controller, [{
		key: 'erase_selection',


		// Erases the selected text inside an `<input/>`
		value: function erase_selection(input, selection) {
			var text = input.value;
			text = text.slice(0, selection.start) + text.slice(selection.end);

			input.value = text;
			(0, _dom.setCaretPosition)(input, selection.start);

			return this.format_input_text();
		}

		// Formats <input/> textual value as a phone number

	}, {
		key: 'getParsedValue',


		// Parses `<input/>` text
		value: function getParsedValue() {
			// <input/> DOM element
			var input = this.get_input_element();

			return (0, _parse3.default)(input.value, undefined, this.parse);
		}
	}]);
	return Input_controller;
}();

var _initialiseProps = function _initialiseProps() {
	var _this = this;

	this.onCut = function (event) {
		setTimeout(_this.format_input_text, 0);
	};

	this.onPaste = function (event) {
		var input = _this.get_input_element();

		var selection = (0, _dom.getSelection)(input);

		// If selection is made,
		// just erase the selected text
		// prior to pasting
		if (selection) {
			_this.erase_selection(input, selection);
		}

		_this.format_input_text();
	};

	this.onChange = function (event) {
		_this.format_input_text();
	};

	this.onKeyDown = function (event) {
		var operation = (0, _dom.getOperation)(event);

		switch (operation) {
			case 'Delete':
			case 'Backspace':
				// Intercept this operation and perform it manually.
				event.preventDefault();

				var input = _this.get_input_element();

				var selection = (0, _dom.getSelection)(input);

				// If selection is made,
				// just erase the selected text,
				// and don't apply any more operations to it.
				if (selection) {
					_this.erase_selection(input, selection);
					return _this.format_input_text();
				}

				// Else, perform the (character erasing) operation manually
				return _this.format_input_text(operation);
		}
	};

	this.format_input_text = function (operation) {
		// <input/> DOM element
		var input = _this.get_input_element();

		var _parse = (0, _parse3.default)(input.value, (0, _dom.getCaretPosition)(input), _this.parse),
		    value = _parse.value,
		    caret = _parse.caret;

		// Apply the pending operation to the <input/> textual value (if any)


		if (operation) {
			var edit_result = (0, _edit2.default)(value, caret, operation);

			value = edit_result.value;
			caret = edit_result.caret;
		}

		// Format the <input/> textual value as a phone number
		// (and reposition the caret accordingly)

		var format_result = (0, _format2.default)(value, caret, _this.format);

		var text = format_result.text;
		caret = format_result.caret;

		// Set <input/> textual value manually to also set caret position
		// and prevent React from resetting the caret position later
		// inside subsequent `render()`.
		// Doesn't work for custom `inputComponent`s for some reason.
		input.value = text;
		// Set caret position (with the neccessary adjustments)
		(0, _dom.setCaretPosition)(input, caret);

		// <input/> textual value may have been changed,
		// so `value` may have been changed too.
		_this.on_change(value);
	};
};

exports.default = Input_controller;
//# sourceMappingURL=input controller.js.map


//////////////////
// WEBPACK FOOTER
// ./~/input-format/build/input controller.js
// module id = 413
// module chunks = 0